import axios from "axios";
import { setUserId, logEvent } from "firebase/analytics";
import { signInWithPopup, signOut, } from "firebase/auth";
import { auth } from "../config";
import { signInWithRedirect } from "firebase/auth";
export const clearLocalStorage = () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem("CRM_token");
    localStorage.setItem("blog", "{}");
};

export const socialSignOut = () => {
    signOut(auth).catch((error) => {
        console.error("Error on signOut:", error?.message);
    });
};

export const saveOnLocalStorage = (token, refreshToken) => {
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", refreshToken);
};
export const getUserDataFromProvider = async (provider) => {
    try {
       const result = await signInWithPopup(auth, provider);

        const user = result.user;

        if (!user?.email) {
            return {
                success: false,
                user: null,
                error: "Login failed. Please try again.",
            };
        }


        return { success: true, user, errorCode: null, error: null };
    } catch (error) {
        return { success: false, errorCode: error.code, error: error.message, user: null };
    }
};
export const checkAndCreateGuestProfile = async ({ user, analytics }) => {
    const {uid, email, photoURL, displayName, emailVerified, accessToken} = user || {};
    const names = displayName ? displayName?.split(" ") : undefined;

  

    try {
        const userExists = await axios
            .get("/guest", { headers: { Authorization: user.accessToken } })
            .then((res) => (res.data?.id ? { success: true } : { success: false }))
            .catch((err) =>
                err?.response?.data?.statusCode === 404 ? { success: false } : { success: false, error: err.message }
            );
  
        if (!userExists?.success) {
            return { success: false, error: "This email is not registered. Please use a registered account." };
        }

        if (analytics) {
            setUserId(analytics, user.uid);
            logEvent(analytics, "login_success");
        }
        if(!emailVerified){
           return {success:false,error:"Your Email is not verified"}
          }

        return { success: true, route: "/", error: "" ,userExists};
    } catch (error) {
        return { success: false, error: "An unexpected error occurred." };
    }
};
